import script from "./AirtimeView.vue?vue&type=script&setup=true&lang=js"
export * from "./AirtimeView.vue?vue&type=script&setup=true&lang=js"

import "./AirtimeView.vue?vue&type=style&index=0&id=7beccaab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7beccaab"]])

export default __exports__